import { IFirebaseContext } from "../context/FirebaseContext";

export interface Prompt {
  key: string;
  value: string;
  description?: string;
  lastModified?: string;
}

export interface PromptsResponse {
  success: boolean;
  data?: Prompt[];
  error?: string;
}

export interface PromptOperationResponse {
  success: boolean;
  data?: any;
  error?: string;
}

export class PromptsService {
  private functions: IFirebaseContext["functions"];

  constructor(functions: IFirebaseContext["functions"]) {
    this.functions = functions;
  }

  async getPrompts(): Promise<PromptsResponse> {
    try {
      const result = await this.functions.getPrompts();

      // Las Cloud Functions con onCall devuelven directamente el resultado
      const data = result.data as any;
      if (data && data.success) {
        console.log("Debugging data success", data);
        return {
          success: true,
          data: data.data || [],
        };
      } else {
        console.log("Debugging data error", data);
        return {
          success: false,
          error: data?.error || "Error al obtener prompts",
          data: [],
        };
      }
    } catch (error) {
      console.error("Error fetching prompts:", error);
      return {
        success: false,
        error: "Error al obtener los prompts",
        data: [],
      };
    }
  }

  async createPrompt(
    key: string,
    value: string,
    description?: string
  ): Promise<PromptOperationResponse> {
    try {
      const result = await this.functions.createPrompt({
        key,
        value,
        description,
      });
      return result.data as PromptOperationResponse;
    } catch (error) {
      console.error("Error creating prompt:", error);
      return {
        success: false,
        error: "Error al crear el prompt",
      };
    }
  }

  async updatePrompt(
    key: string,
    value: string,
    description?: string
  ): Promise<PromptOperationResponse> {
    try {
      const result = await this.functions.updatePrompt({
        key,
        value,
        description,
      });
      return result.data as PromptOperationResponse;
    } catch (error) {
      console.error("Error updating prompt:", error);
      return {
        success: false,
        error: "Error al actualizar el prompt",
      };
    }
  }

  async deletePrompt(key: string): Promise<PromptOperationResponse> {
    try {
      const result = await this.functions.deletePrompt({ key });
      return result.data as PromptOperationResponse;
    } catch (error) {
      console.error("Error deleting prompt:", error);
      return {
        success: false,
        error: "Error al eliminar el prompt",
      };
    }
  }
}
